import { dataCheckSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCheckSquare = /*#__PURE__*/createIcon(dataCheckSquare)
export default IconCheckSquare
